export default "__VITE_ASSET__BEtQhBSC__"